import type { Static } from 'runtypes';
import { LocaleContextRuntype } from './locale';
import { PageContextRuntype } from './page';
import { TimeZoneContextRuntype } from './time-zone';
import { UserAgentContextRuntype } from './user-agent';

const BrowserContextRuntype = LocaleContextRuntype.And(PageContextRuntype)
  .And(TimeZoneContextRuntype)
  .And(UserAgentContextRuntype);

type BrowserContext = Static<typeof BrowserContextRuntype>;

export { BrowserContextRuntype };
export type { BrowserContext };
